import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { Character } from '../types/character';
import * as characterService from '../../services/characterService';

/**
 * 存储当前选择的角色卡ID
 * 使用localStorage持久化
 */
export const selectedCharacterIdAtom = atomWithStorage<string>('selectedCharacterId', 'default');

/**
 * 存储所有角色卡
 */
export const charactersAtom = atom<Character[]>([]);

/**
 * 是否正在加载角色卡
 */
export const charactersLoadingAtom = atom<boolean>(false);

/**
 * 角色卡加载错误
 */
export const charactersErrorAtom = atom<string | null>(null);

/**
 * 加载角色卡动作
 */
export const fetchCharactersAtom = atom(
  null,
  async (get, set) => {
    try {
      set(charactersLoadingAtom, true);
      set(charactersErrorAtom, null);
      
      const characters = await characterService.fetchCharacters();
      set(charactersAtom, characters);
    } catch (error) {
      console.error('Failed to fetch characters:', error);
      set(charactersErrorAtom, error instanceof Error ? error.message : 'Unknown error');
    } finally {
      set(charactersLoadingAtom, false);
    }
  }
);

/**
 * 当前选择的角色卡
 */
export const selectedCharacterAtom = atom(
  get => {
    const characters = get(charactersAtom);
    const selectedId = get(selectedCharacterIdAtom);
    return characters.find(char => char.id === selectedId) || characters[0];
  }
); 